import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { keyframes } from '@mui/system';
import { useLocalization } from '@/hooks/useLocalization';

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
`;

interface SyncErrorIconProps {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
}

export const SyncErrorIcon: React.FC<SyncErrorIconProps> = ({
  onClick,
  fontSize = 'small',
}) => {
  const { t } = useLocalization();
  const tooltip = t('connectionError.iconTooltip');

  const icon = (
    <ErrorOutlineIcon
      data-testid='sync-error-icon'
      color='error'
      fontSize={fontSize}
      sx={{ animation: `${fadeIn} 200ms ease-out`, verticalAlign: 'middle' }}
    />
  );

  if (onClick) {
    return (
      <Tooltip title={tooltip}>
        <IconButton
          size='small'
          onClick={onClick}
          aria-label={tooltip}
          sx={{ p: 0.25 }}
        >
          {icon}
        </IconButton>
      </Tooltip>
    );
  }

  return <Tooltip title={tooltip}>{icon}</Tooltip>;
};
